import React, { useContext, useEffect, useState } from "react";
import Card from "../../../../components/Cards/Basic";
import axios from "../../../../config/axios";
import { useParams } from "react-router-dom";
import { Button, Col, Row, Tab, Tabs } from "react-bootstrap";
import {
  showErrorToast,
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import { dateTimeFormatter } from "../../../../global";
import BackButton from "../../../../components/UiComponents/Buttons/BackButton";
import { useTranslation } from "react-i18next";
import {
  faAddressCard,
  faBed,
  faCalendarMinus,
  faCalendarPlus,
  faEnvelope,
  faLanguage,
  faLock,
  faLockOpen,
  faNoteSticky,
  faPencil as EditIcon,
  faPhone,
  faRightToBracket,
  faUser,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import useModal from "../../../../components/Modal/hooks/useModal";
import BookingCheckoutDialog from "./BookingCheckoutDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EllipsisDropdown, {
  EllipsisDropdownItem,
  EllipsisDropdownSection,
} from "../../../../components/EllipsisDropdown";
import GuestSection from "./GuestSection";
import InvoiceSection from "./InvoiceSection";
import BookingGateLogSection from "./BookingGateLogSection";
import { DashboardContext } from "../../../../routes/DashboardRoutes";
import useFilter from "../../../../global/useFilter";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import BookingSection from "./BookingSection";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import { navigateTo } from "src/global/navigationHelper";
import StayAccessDialog from "src/pages/Dashboard/Bookings/StayDetailsPage/Dialogs/StayAccessDialog";
import EditInternalNoteDialog from "src/pages/Dashboard/Bookings/StayDetailsPage/Dialogs/EditInternalNoteDialog";
import SendReservationSummaryDialog from "./Dialogs/SendReservationSummaryDialog";

const StayDetailsPage = ({ optin_id }) => {
  const { id = optin_id } = useParams() ?? {};
  const [stay, setStay] = useState(null);
  const { isShow: showCheckoutDialog, toggle: toggleCheckoutDialog } =
    useModal();
  const { settings } = useContext(DashboardContext);
  const { t } = useTranslation("dashboard");
  const { isShow: showDeleteDialog, toggle: toggleDeleteDialog } = useModal();
  const { isShow: showAccessDialog, toggle: toggleAccessDialog } = useModal();
  const { isShow: showSummaryDialog, toggle: toggleSummaryDialog } = useModal();
  const {
    isShow: showEditInternalNoteDialog,
    toggle: toggleEditInternalNoteDialog,
  } = useModal();

  const location = useLocation();

  const { pathname } = location;

  const { filter, setFilter } = useFilter(pathname, {
    activeTab: "bookings",
  });

  const getStay = () => {
    axios
      .get(`/api/v1/stays/${id}.json`)
      .then(function (response) {
        setStay(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  async function extend() {
    const response = await axios.post(
      `/api/v1/stays/${stay.id}/bookings/extend_booking.json`
    );
    navigateTo(
      `/dashboard/stays/${stay.id}/bookings/${response.data.id}/edit`,
      {
        openBookingOfferId: response.data.id,
      }
    );
  }

  const revertCheckout = () => {
    axios
      .post(`/api/v1/stays/${stay.id}/revert_checkout.json`)
      .then(function (response) {
        getStay();
        showSuccessToast();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  const deleteStay = () => {
    axios
      .delete(`/api/v1/stays/${id}.json`)
      .then(function () {
        getStay();
        navigateTo(`/dashboard`);
      })
      .catch(function (error) {
        showValidationErrorToast(error);
      });
  };

  const handleInternalNoteSuccess = () => {
    toggleEditInternalNoteDialog();
    getStay();
    showSuccessToast();
  };

  function handleCheckoutSuccess() {
    getStay();
    toggleCheckoutDialog();
  }

  function handleSummarySuccess(updatedStay) {
    setStay(updatedStay);
    toggleSummaryDialog();
    showSuccessToast("Der E-Mail-Versand wurde beauftragt.");
  }

  function handleEditStay() {
    navigateTo(`/dashboard/stays/${id}/edit`);
  }

  useEffect(() => {
    getStay();
  }, []);

  const bookingTitle = (
    <div className="d-flex w-100 align-items-center justify-content-between">
      <div className={"d-flex align-items-center"}>
        <BackButton fallbackRoute={`/dashboard`} />{" "}
        <p className="mb-0">
          {t(
            stay?.contact_full_name
              ? "booking_details.title_with_guest"
              : "booking_details.title",
            { name: stay?.contact_full_name, id: stay?.id }
          )}
        </p>
      </div>

      <div>
        <EllipsisDropdown>
          <EllipsisDropdownSection>
            <EllipsisDropdownItem onClick={handleEditStay}>
              Bearbeiten
            </EllipsisDropdownItem>
          </EllipsisDropdownSection>
          <EllipsisDropdownSection>
            <EllipsisDropdownItem onClick={toggleDeleteDialog}>
              Löschen
            </EllipsisDropdownItem>
          </EllipsisDropdownSection>
        </EllipsisDropdown>
      </div>
    </div>
  );

  return (
    <>
      {stay && (
        <div className={"booking-details"}>
          <Card
            title={bookingTitle}
            footer={
              <Row>
                <Col>
                  {!stay.checkout_confirmed_at && (
                    <Button
                      className="mr-2"
                      variant="secondary"
                      onClick={extend}
                    >
                      Buchung hinzufügen
                    </Button>
                  )}
                  {!stay.checkout_confirmed_at ? (
                    <Button
                      className="mr-2"
                      variant="primary"
                      onClick={() => {
                        toggleCheckoutDialog();
                      }}
                    >
                      Checkout
                    </Button>
                  ) : (
                    <Button
                      className="mr-2"
                      variant="primary"
                      onClick={revertCheckout}
                    >
                      Checkout rückgängig machen
                    </Button>
                  )}
                </Col>
              </Row>
            }
          >
            <Row>
              <div className="d-flex w-100 rounded booking-overview-container">
                <Row className="w-100 justify-content-between p-2">
                  <Col>
                    <div>
                      <h5 className="font-weight-bold text-black">
                        Stammdaten
                      </h5>
                    </div>
                    <Row className={"justify-content-between mb-3"}>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          Datum von
                        </div>
                        <FontAwesomeIcon icon={faCalendarPlus} />
                        <span className="pl-2 text-black-50">
                          {stay.from && dateTimeFormatter(stay.from)}
                        </span>
                      </Col>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          Datum bis
                        </div>
                        <FontAwesomeIcon icon={faCalendarMinus} />
                        <span className="pl-2 text-black-50">
                          {stay.to && dateTimeFormatter(stay.to)}
                        </span>
                      </Col>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          Übernachtungen
                        </div>
                        <FontAwesomeIcon icon={faBed} height={24} />
                        <span className="pl-2 text-black-50">
                          {stay.nights}
                        </span>
                      </Col>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          Checkout
                        </div>
                        <FontAwesomeIcon icon={faRightToBracket} height={24} />
                        <span className="pl-2 text-black-50">
                          {stay.checkout_confirmed_at
                            ? dateTimeFormatter(stay.checkout_confirmed_at)
                            : "-"}
                        </span>
                      </Col>
                    </Row>
                    <Row className={"justify-content-between mb-3"}>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          {t("booking_details.contact_details.label")}
                        </div>
                        <div>
                          <FontAwesomeIcon icon={faUser} height={24} />
                          <span className="pl-2 text-black-50">
                            {stay.contact_full_name ?? "-"}
                          </span>
                        </div>
                        <div>
                          <FontAwesomeIcon icon={faPhone} height={24} />
                          <span className="pl-2 text-black-50">
                            {stay.contact_phone ?? "-"}
                          </span>
                        </div>
                        <div>
                          <FontAwesomeIcon icon={faEnvelope} height={24} />
                          <span className="pl-2 text-black-50">
                            {stay.contact_email ?? "-"}
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          NFC Karte
                        </div>
                        <FontAwesomeIcon icon={faAddressCard} height={24} />
                        <span className="pl-2 text-black-50">
                          {stay.nfc_card_uid ? (
                            stay.nfc_card_uid
                          ) : (
                            <FontAwesomeIcon
                              icon={faWarning}
                              className={"text-warning"}
                            />
                          )}
                        </span>
                      </Col>
                      <Col>
                        <div
                          className="font-weight-bolder text-black d-flex cursor-pointer"
                          onClick={toggleAccessDialog}
                        >
                          <div>
                            <div>
                              {t(
                                "booking_details.access_dialog.drive_in.label"
                              )}
                              /
                            </div>
                            <div className={"text-center"}>
                              {stay.can_drive_in ? (
                                <FontAwesomeIcon
                                  icon={faLockOpen}
                                  className={"text-success"}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faLock}
                                  className={"text-danger"}
                                />
                              )}
                            </div>
                          </div>
                          <div>
                            <div>
                              {t(
                                "booking_details.access_dialog.drive_out.label"
                              )}
                              /
                            </div>
                            <div className={"text-center"}>
                              {stay.can_drive_out ? (
                                <FontAwesomeIcon
                                  icon={faLockOpen}
                                  className={"text-success"}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faLock}
                                  className={"text-danger"}
                                />
                              )}
                            </div>
                          </div>
                          <div>
                            <div>
                              {t(
                                "booking_details.access_dialog.checkout.label"
                              )}
                            </div>
                            <div className={"text-center"}>
                              {stay.can_checkout ? (
                                <FontAwesomeIcon
                                  icon={faLockOpen}
                                  className={"text-success"}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faLock}
                                  className={"text-danger"}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="font-weight-bolder text-black">
                          Sprache
                        </div>
                        <FontAwesomeIcon icon={faLanguage} height={24} />
                        <span className="pl-2 text-black-50">
                          {t(`common:general.languages.${stay.language}`)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="internal-note-column">
                        <div className="font-weight-bolder text-black">
                          {t("booking_details.internal_note.label")}
                        </div>
                        <div className="internal-note d-flex align-items-center">
                          <div
                            className="internal-note-content d-flex align-items-center"
                            title={stay.internal_note}
                          >
                            <FontAwesomeIcon icon={faNoteSticky} height={24} />
                            <span className="internal-note-text pl-2 text-black-50">
                              {stay.internal_note}
                            </span>
                          </div>
                          <FontAwesomeIcon
                            icon={EditIcon}
                            className="ml-1"
                            onClick={toggleEditInternalNoteDialog}
                          />
                        </div>
                      </Col>
                      <Col></Col>
                      <Col></Col>
                      <Col></Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Row>
          </Card>
          <Row className={"mb-2"}>
            <Col>
              <Tabs
                activeKey={filter.activeTab}
                onSelect={(tab) => setFilter({ activeTab: tab })}
              >
                <Tab title={"Buchungen"} eventKey={"bookings"}>
                  <BookingSection
                    stay={stay}
                    getStay={getStay}
                    extend={extend}
                  />
                </Tab>
                <Tab
                  title={`Gäste (${stay.guests.length})`}
                  eventKey={"guests"}
                >
                  {filter.activeTab === "guests" &&
                    settings?.business?.guest_registration_enabled && (
                      <GuestSection stay={stay} getStay={getStay} />
                    )}
                </Tab>
                <Tab title="Rechnungen" eventKey={"invoices"}>
                  {filter.activeTab === "invoices" && (
                    <InvoiceSection stay={stay} getStay={getStay} />
                  )}
                </Tab>

                <Tab title="Aktivitäten" eventKey={"gatelogs"}>
                  {filter.activeTab === "gatelogs" && (
                    <BookingGateLogSection stay={stay} />
                  )}
                </Tab>
                {stay.comment && (
                  <Tab title="Kommentar" eventKey={"comments"}>
                    <Card title={"Kommentar"}>
                      <p className={"comment"}>{stay.comment}</p>
                    </Card>
                  </Tab>
                )}
              </Tabs>
            </Col>
          </Row>
          <Row>
            <Col></Col>
          </Row>
        </div>
      )}

      {showCheckoutDialog && (
        <BookingCheckoutDialog
          stay={stay}
          handleClose={toggleCheckoutDialog}
          handleSubmit={handleCheckoutSuccess}
        />
      )}
      {showDeleteDialog && (
        <ConfirmDeleteDialog
          show={true}
          handleClose={() => {
            toggleDeleteDialog();
          }}
          handleDelete={deleteStay}
        />
      )}

      {showAccessDialog && (
        <StayAccessDialog stay={stay} handleClose={toggleAccessDialog} />
      )}
      {showEditInternalNoteDialog && (
        <EditInternalNoteDialog
          stay={stay}
          handleClose={toggleEditInternalNoteDialog}
          handleSuccess={handleInternalNoteSuccess}
        />
      )}
      {showSummaryDialog && (
        <SendReservationSummaryDialog
          stay={stay}
          handleClose={toggleSummaryDialog}
          handleSuccess={handleSummarySuccess}
        />
      )}
    </>
  );
};

export default StayDetailsPage;
